import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'ui';

const getDisabledState = ({ slideCount, currentSlide, right }) => {
  if (slideCount < 1 || slideCount === 1) {
    return true;
  }
  if (right) {
    return slideCount - 1 === currentSlide;
  }
  return currentSlide === 0;
};

const StyledButton = styled(Button)`
  position: absolute;
  bottom: 0;
  background-color: ${p => p.theme.colors.themeSecondary};
  ${p => p.right && 'right: 0'};
`;

const SliderButton = (props) => {
  const { slideCount, icon, onClick, currentSlide, right } = props;
  return (
    <StyledButton
      icon={icon}
      onClick={onClick}
      disabled={getDisabledState({ slideCount, currentSlide, right })}
      type='secondary'
      right={right}
    />
  );
};

SliderButton.propTypes = {
  icon: PropTypes.string,
  onClick: PropTypes.func,
  slideCount: PropTypes.number,
  currentSlide: PropTypes.number,
  right: PropTypes.bool,
};

export default SliderButton;
